var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarkerOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.42615 5.63143C3.42615 2.83386 5.70239 0.557617 8.49996 0.557617C11.2975 0.557617 13.5738 2.83386 13.5738 5.63143C13.5738 10.0117 8.93758 15.4401 8.74001 15.669C8.67976 15.7388 8.59826 15.7724 8.49996 15.7791C8.40863 15.7791 8.32174 15.7397 8.26149 15.6709C8.06393 15.4458 3.42615 10.1072 3.42615 5.63143Z",
    stroke: "currentColor",
    strokeWidth: 0.75
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 5.83691,
    r: 1.98291,
    stroke: "currentColor",
    strokeWidth: 0.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerOutline);
export default __webpack_public_path__ + "static/media/marker-outline.714bf4ccbafff372fb12b2c1908e108f.svg";
export { ForwardRef as ReactComponent };